const week = {
    price: 299,
    priceUSD: 6.99,
    identifier: 'week',
    interval: '7 days',
    fancyName: 'Премиум на неделю',
    currency: 'RUB',
    getFancyPrice(language) {
        if (language === 'en') {
            return `$${this.priceUSD}`;
        }
        return `${this.price} ₽`;
    },
};

const month = {
    price: 499,
    priceUSD: 14.99,
    fancyName: 'Премиум на месяц',
    identifier: 'month',
    interval: '1 month',
    currency: 'RUB',
    getFancyPrice(language) {
        if (language === 'en') {
            return `$${this.priceUSD}`;
        }
        return `${this.price} ₽`;
    },
};

const year = {
    price: 1499,
    priceUSD: 29.99,
    fancyName: 'Премиум на год',
    identifier: 'year',
    interval: '12 months',
    currency: 'RUB',
    getFancyPrice(language) {
        if (language === 'en') {
            return `$${this.priceUSD}`;
        }
        return `${this.price} ₽`;
    },
};


export const premiums = [week, month, year];
